import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { IconShieldCheck, IconShieldX } from "@tabler/icons-react";
import { api, formatApiError } from "@/lib/api";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import { useI18n } from "@/contexts/I18nContext";

export default function VerifySello() {
  const { code } = useParams();
  const { lang } = useI18n();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => { (async () => {
    try { const { data } = await api.get(`/public/sello/verify/${code}`); setData(data); }
    catch (e) { setError(formatApiError(e)); }
    finally { setLoading(false); }
  })(); }, [code]);

  return (
    <div className="bg-paper min-h-screen">
      <SiteNav />
      <section className="py-16">
        <div className="wrap max-w-[640px]">
          {loading ? (
            <p className="text-tert text-[12px] font-mono uppercase">{lang === "es" ? "Verificando…" : "Verifying…"}</p>
          ) : error || !data ? (
            <div className="card border-l-[4px] border-l-errtext" data-testid="verify-invalid">
              <div className="flex items-center gap-3">
                <IconShieldX size={28} className="text-errtext" />
                <div>
                  <h1 className="font-display text-[22px] font-medium">{lang === "es" ? "Sello no encontrado" : "Seal not found"}</h1>
                  <p className="text-muted text-[13.5px] mt-1">{lang === "es" ? "Este código no corresponde a una maestra sombra certificada por Chiessa Institute o el sello no está vigente." : "This code is not a valid seal."}</p>
                </div>
              </div>
              <p className="font-mono text-tert text-[12px] mt-4">Código: {code}</p>
            </div>
          ) : (
            <div className="card border-l-[4px] border-l-oktext" data-testid="verify-valid">
              <div className="flex items-start gap-4 flex-wrap">
                <IconShieldCheck size={34} className="text-oktext mt-1" />
                <div className="flex-1">
                  <span className="tag bg-okbg text-oktext">{lang === "es" ? "Sello vigente" : "Active seal"}</span>
                  <h1 className="font-display text-[26px] font-medium mt-2">{data.name}</h1>
                  <p className="text-tert text-[13px] mt-1">
                    {lang === "es" ? "Maestra sombra certificada por" : "Shadow teacher certified by"} <b>Chiessa Institute</b>
                  </p>
                  <p className="text-[14px] mt-3">{data.bio}</p>
                  <div className="flex flex-wrap gap-1.5 mt-3">
                    {(data.specialties || []).map((s) => <span key={s} className="tag">{s}</span>)}
                  </div>
                  <div className="text-tert text-[12.5px] mt-4 space-y-1">
                    <p>{lang === "es" ? "Años de experiencia" : "Years of experience"}: <b>{data.years_experience}</b></p>
                    <p>{lang === "es" ? "Certificada el" : "Certified on"}: {new Date(data.issued_at).toLocaleDateString(lang === "es" ? "es-HN" : "en-US")}</p>
                    <p>{lang === "es" ? "Vigente hasta" : "Valid until"}: {new Date(data.expires_at).toLocaleDateString(lang === "es" ? "es-HN" : "en-US")}</p>
                    <p className="font-mono">{lang === "es" ? "Código" : "Code"}: <b>{data.verification_code}</b></p>
                  </div>
                </div>
                <div className="bg-white p-2 rounded-lg border border-line">
                  <QRCodeSVG value={window.location.href} size={110} fgColor="#0A3F33" level="M" />
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
